import React, {memo, useEffect, useState} from 'react';

import {TMediaEntry} from '@chancer/common/lib/interfaces/firestore/FirestoreInterfaces';
import {EditMedia} from './EditMedia';
import {Input, TextareaInput} from './FormElements';

interface IProps {
  label: string;
  value: TMediaEntry;
  mediaType?: 'image' | 'video';
  removable?: boolean;
  disabled: boolean;
  dimensions: [width: number, height: number];
  children?: React.ReactNode;
  selectedFile?: File;
  multiline?: boolean;
  fillTransparent?: boolean;
  setIsUpdating: (updating: boolean) => void;
  onUpdate: (isImageUpload: boolean, media: TMediaEntry) => void;
}

export const MediaItem: React.FC<IProps> = memo((props) => {
  const {value} = props;
  const [currentValue, setCurrentValue] = useState(props.value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  if (!currentValue) {
    return null;
  }

  const _onBlur = (u: string) => {
    const newValue = {...currentValue, caption: u};
    setCurrentValue(newValue);
    props.onUpdate(true, newValue);
  };

  const _onCaptionChange = (u: string) => {
    const newValue = {...currentValue, caption: u};
    setCurrentValue(newValue);
    props.onUpdate(false, newValue);
  };

  const _onRemove = (u: TMediaEntry) => {
    const newValue = u;
    setCurrentValue(newValue);
    props.onUpdate(false, newValue);
  };

  return (
    <>
      {props.multiline ? (
        <TextareaInput
          key="caption"
          label={props.label}
          inputProps={{
            rows: 3,
            disabled: props.disabled,
            value: currentValue.caption || '',
            onChange: (e) => _onCaptionChange(e.target.value),
            onBlur: (e) => _onBlur(e.target.value),
          }}
        />
      ) : (
        <Input
          key="caption"
          label={props.label}
          inputProps={{
            disabled: props.disabled,
            value: currentValue.caption || '',
            onChange: (e) => _onCaptionChange(e.target.value),
            onBlur: (e) => _onBlur(e.target.value),
          }}
        />
      )}
      {props.children}
      <EditMedia
        {...props}
        onUpdate={(media) =>
          props.onUpdate(true, {
            ...media,
            ...(currentValue.caption ? {caption: currentValue.caption} : {}),
          })
        }
        onRemove={_onRemove}
        fillTransparent={props.fillTransparent}
      />
    </>
  );
});
